export default __webpack_public_path__ + "static/media/role-blue.f9ba2545.svg";